module.exports = __webpack_public_path__ + "static/img/sx@2x.c479195.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sx@2x.png
// module id = J9DB
// module chunks = 2